import $ from 'jquery';
import 'bootstrap/js/dist/collapse';

function openAndMoveToAccordion() {
	const $target = $(window.location.hash);
	if ($target.length && $target.closest('.accordion').length) {
		$target
			.closest('.accordion-item')
			.find('.accordion-button')
			.removeClass('collapsed');
		const collapseTarget = $target
			.closest('.accordion-item')
			.find('.accordion-button')
			.data('bs-target');
		$(collapseTarget).addClass('show');
		window.location = window.location.hash;
	}
}

export default class Accordion {
	init() {
		if (window.location.hash) {
			openAndMoveToAccordion();
		}

		$(window).on('hashchange', () => {
			openAndMoveToAccordion();
		});
	}
}
